import axios from "axios";
import ErrorParser from '../../../helpers/services/error.parser';

const SamplingpointsService = {
  samplingpoints: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/samplingpoints",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);

    }
  },
   mediavalues: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/samplingpoints/mv",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }, 
   measurementregimes: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/samplingpoints/mr",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },   
   assessmenttypes: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/samplingpoints/at",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },    
   stationclassifications: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/samplingpoints/sc",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  stations: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/samplingpoints/s",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },  
  delete: async function (id) {
    const requestData = {
      method: "post",
      url: "/api/management/samplingpoints/delete",
      data: { id: id }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  update: async function (samplingpoints) {
    const requestData = {
      method: "post",
      url: "/api/management/samplingpoints/update",
      data: samplingpoints
    };
    try {
      // debugger;
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  import: async function (formData) {
    const requestData = {
      method: "post",
      url: "/imports/sampling_points",
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    };
        
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default SamplingpointsService;
